import { Component } from '@angular/core';
import { BaseContainer } from '../../../base/BaseContainer';
import * as actions from '../../../../core/store/service/service.actions';
import { Service } from '../../../../core/store/service/service.interface';
import { fadeInAnimation } from '../../../../animations';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.container.html',
  styleUrls: ['./contact-page.container.scss'],
  animations: [fadeInAnimation],
})
export class ContactPageContainer extends BaseContainer {
  isSaving: boolean = false;

  constructor() {
    super();

    this.store
      .select('service')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((service: Service) => {
        this.isSaving = service.contact.saving;
      });
  }

  sendForm(formData) {
    this.store.dispatch(actions.contactSendMessageAction({ message: formData }));
  }
}
